import React from "react";
import { FaArrowLeft, FaEdit, FaTrash } from "react-icons/fa";

export default function RecordActions({ onBack, onEdit, onDelete }) {
  return (
    <div className="d-flex justify-content-end align-items-center gap-2 mb-3">
      {onBack && (
        <button type="button" className="btn btn-outline-secondary" onClick={onBack}>
          <FaArrowLeft className="me-1" aria-hidden="true" />
          Back
        </button>
      )}
      {onEdit && (
        <button type="button" className="btn btn-outline-primary" onClick={onEdit}>
          <FaEdit className="me-1" aria-hidden="true" />
          Edit
        </button>
      )}
      {onDelete && (
        <button type="button" className="btn btn-outline-danger" onClick={onDelete}>
          <FaTrash className="me-1" aria-hidden="true" />
          Delete
        </button>
      )}
    </div>
  );
}
